module.exports = __webpack_public_path__ + "static/media/tiefighter.59950944.png";